import { render } from "./AuthGuard.vue?vue&type=template&id=688020da&scoped=true&ts=true&lang=html"
import script from "./AuthGuard.vue?vue&type=script&lang=ts"
export * from "./AuthGuard.vue?vue&type=script&lang=ts"

import "./AuthGuard.vue?vue&type=style&index=0&id=688020da&lang=css&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-688020da"]])

export default __exports__